import { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import './_DownloadFeeds.scss';
import { litrals } from '../../../../../constants/Litrals';
import DataFeedModal from '../../molecules/DataFeedModal';
import SubscribedFeedsCard from '../../../../ntisui/Molecules/SubscribedFeedsCard';

import { downloadDatafeeds } from './mockData.json';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { LoginType } from '../../../template/types/IHeader';
import { configureMap } from '../../../../../config/AppConfig';
import { breadcrumbsLinks } from '../../../../../constants/Constants';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';
import { getData } from '../../../../../api/ApiCommunication';

const DownloadFeeds = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModaldata] = useState(null);
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [msalData, setMsalData] = useState<any>({});
  const [isApproved, setIsApproved] = useState(false);

  useEffect(() => {
    configureMap().then((result: any) => setMsalData(result));
    async function fetchGetSubscriberData() {
      await getData('approveSubscriber', '').then((res) => {
        setIsApproved(res.data.data?.isApproved);
      });
    }
    isAuthenticated && fetchGetSubscriberData();
  }, []);

  const handleModal = (info: any) => {
    setShowModal(true);
    setModaldata(info);
  };

  const handleLogin = (loginType: string) => {
    if (
      loginType === LoginType.Signin &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const loginRequest = {
        scopes: [msalData.B2C_Scope],
      };
      instance.loginRedirect(loginRequest).catch(() => {
        return;
      });
    } else if (
      loginType === LoginType.Signup &&
      inProgress === InteractionStatus.None &&
      !isAuthenticated
    ) {
      const signUpRequest = {
        scopes: [msalData.B2C_Scope],
        authority: msalData.B2C_SignUp,
      };
      instance.loginRedirect(signUpRequest).catch(() => {
        return;
      });
    }
  };
  const [progress, setProgress] = useState('');

  async function getDownloadFeedData(assetType?: any): Promise<any> {
    const response = await getData(
      'downloadDataFeed',
      '',
      `?modelType=${assetType}`,
      {
        responseType: 'blob',
        onDownloadProgress: (progressEvent: any) => {
          setProgress(assetType);
          const { loaded, total } = progressEvent;
          const percentCompleted = Math.round((loaded * 100) / total);
          if (percentCompleted == 100) {
            setTimeout(() => {
              setProgress('');
            }, 150);
          }
        },
      },
    );
    // return response;
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a link and click it to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${assetType}.tar.gz`); // Set the desired file name
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return (
    <>
      <div className="breadcrum-padding">
        <Breadcrumbs links={breadcrumbsLinks.downloads} />
      </div>
      <Row
        className="download-feed-container"
        data-testid="download-feed-container"
      >
        <Col className="container-left card-container-new">
          <h4 className="section-heading">{litrals.aboutDownloadDataFeed}</h4>
          <div className="content-paragraph">
            <p className="section-paragraph">
              {litrals.aboutDownloadDataFeedContent}
            </p>
          </div>
        </Col>
        <Col className="card-container-new container-right">
          <h4>{litrals.downloads}</h4>
          {!isAuthenticated && (
            <div className="content-paragraph">
              <p className="section-paragraph">
                {litrals.subscribeToDataFeed}{' '}
                <a
                  tabIndex={0}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogin(LoginType.Signin);
                  }}
                  href="javascript: void(0)"
                >
                  {litrals.login}
                </a>{' '}
                {litrals.dontHaveAccount}
                <a
                  tabIndex={0}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogin(LoginType.Signup);
                  }}
                  href="javascript: void(0)"
                >
                  {litrals.register}
                </a>
              </p>
            </div>
          )}
          {!isApproved && isAuthenticated && (
            <p className="content-paragraph mt-4">
              Waiting for operator approval!
            </p>
          )}
          {isApproved && isAuthenticated && (
            <>
              <p className="downloadfeeds-section-heading">
                {litrals.allDataFeedsDelivered}
              </p>
              {downloadDatafeeds.map((item: any, index: any) => {
                return (
                  <SubscribedFeedsCard
                    data-testid={'download-feed-card' + index}
                    key={'downloadfeedscard' + index}
                    feedname={item.dataFeedName}
                    onInfoIconClick={() => handleModal(item)}
                    onButtonClick={() =>
                      progress != item.assetType &&
                      getDownloadFeedData(item.assetType)
                    }
                    status={item.subscriberDataFeedStatus}
                    statusClass=""
                    buttonText={
                      progress == item.assetType
                        ? 'Downloading'
                        : litrals.download
                    }
                  />
                );
              })}
              <DataFeedModal
                onClose={() => setShowModal(false)}
                show={showModal}
                title={modalData?.dataFeedName}
                content={modalData?.dataFeedDescription}
              />
            </>
          )}
        </Col>
      </Row>
    </>
  );
};
export default DownloadFeeds;
